module.exports = __webpack_public_path__ + "static/img/AU.4bdfe88d.svg";